import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './header.css';


const Header = () => {
  const location = useLocation();

  const [scrolled, setScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);

  // header transparent -> plus opaque quand on scrolle
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // refermer le menu "Activités" quand on change de page
  useEffect(() => {
    setOpenDropdown(false);
  }, [location.pathname]);

  // scroll fluide vers les sections si déjà sur /
  const handleAnchorClick = (e, anchor) => {
    e.preventDefault();
    const section = document.getElementById(anchor);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = `/#${anchor}`;
    }
  };

  // toggle du dropdown au clic
  const toggleDropdown = () => {
    setOpenDropdown(prev => !prev);
  };

  const handleDropdownLinkClick = () => {
    setOpenDropdown(false);
  };

  return (
    <header className={`main-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-inner">
        <div className="header-left">
          <Link to="/" className="logo-text">LE HAMEAU DU SORBIER</Link>

          <nav className="nav-links">
            {/* Le Lieu */}
            <div className="nav-item">
              {location.pathname === '/' ? (
                <a
                  href="#lieu"
                  onClick={(e) => handleAnchorClick(e, 'lieu')}
                  className="nav-link"
                >
                  Le Lieu
                </a>
              ) : (
                <Link to="/" className="nav-link">
                  Le Lieu
                </Link>
              )}
            </div>

            {/* Réserver */}
            <div className="nav-item">
              {location.pathname === '/' ? (
                <a
                  href="#booking"
                  onClick={(e) => handleAnchorClick(e, 'booking')}
                  className="nav-link"
                >
                  Réserver
                </a>
              ) : (
                <Link to="/" className="nav-link">
                  Réserver
                </Link>
              )}
            </div>

            {/* Galerie */}
            <div className="nav-item">
              <Link
                to="/galerie"
                className={`nav-link ${location.pathname === '/galerie' ? 'active' : ''}`}
              >
                Galerie
              </Link>
            </div>

            {/* Activités (dropdown) */}
            <div className="nav-item nav-dropdown">
              <button
                className={`nav-link nav-dropdown-toggle ${
                  location.pathname.startsWith('/activites') ? 'active' : ''
                }`}
                onClick={toggleDropdown}
              >
                Activités ▾
              </button>

              {openDropdown && (
                <div className="dropdown-menu">
                  <Link
                    to="/activites-hameau"
                    className="dropdown-item"
                    onClick={handleDropdownLinkClick}
                  >
                    Activités au sein du hameau
                  </Link>

                  <Link
                    to="/activites-exterieur"
                    className="dropdown-item"
                    onClick={handleDropdownLinkClick}
                  >
                    Activités extérieures
                  </Link>
                </div>
              )}
            </div>
          </nav>
        </div>
{/* 
        <div className="header-right">
          <img src="/logoCrop.png" alt="Logo Sorbier" className="logo-img" />
        </div> */}
      </div>
    </header>
  );
};

export default Header;
